import { computed } from 'vue'
import { useAuthorizationStore } from '@/stores/authorization'

export default function useProfilePermissions() {
  const authorizationStore = useAuthorizationStore()

  const canUploadPolygon = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'add_sectionselectionpolygon'
    })
  })

  const canAddSectionLine = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'add_sectionline'
    })
  })

  const canDeleteSectionLineUploadCollection = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'delete_sectionlineuploadcollection'
    })
  })

  const canEditSectionLineUploadCollection = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'change_sectionlineuploadcollection'
    })
  })

  const canRemoveSectionLineGIPoint = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'delete_sectionlinegipoint'
    })
  })

  const canAddSectionLineGIPoint = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'add_sectionlinegipoint'
    })
  })

  const canEditSectionLine = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'change_sectionline'
    })
  })

  const canDeleteSectionLine = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'delete_sectionline'
    })
  })

  return {
    canUploadPolygon,
    canAddSectionLine,
    canDeleteSectionLineUploadCollection,
    canEditSectionLineUploadCollection,
    canRemoveSectionLineGIPoint,
    canAddSectionLineGIPoint,
    canEditSectionLine,
    canDeleteSectionLine
  }
}
